import { Component, OnInit, Output } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CpfService } from "src/app/shared/services/cpf.service";
import { CpfModalService } from "./cpf-modal.service";

@Component({
  selector: "app-cpf-modal",
  templateUrl: "./cpf-modal.component.html",
  styleUrls: ["./cpf-modal.component.css"],
})
export class CpfModalComponent implements OnInit {
  cpfForm: FormGroup;
  @Output() cpfValid: boolean;
  cpfValue: string;
  horizontalPosition: MatSnackBarHorizontalPosition = "center";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _cpfService: CpfModalService,
    private cpfModalDialog: MatDialog,
    private cpfService: CpfService,
    private _snackBar: MatSnackBar
  ) {
    this.cpfForm = this.formBuilder.group({
      cpf: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.validarCPF();
  }

  openCaptacao() {
    this.verificarCPF(this.cpfValue);
  }

  validarCPF() {
    this.cpfForm.valueChanges.subscribe(() => {
      let soma = 0;
      let resto;
      let inputCPF = this.cpfForm.get("cpf").value;
      if (inputCPF.length < 11) {
        this.cpfValid = false;
        return;
      }

      if (!this.cpfValidao0a9Sequencial(inputCPF)) return;

      for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(inputCPF.substring(9, 10))) {
        this.cpfForm.get("cpf").setErrors({ invalid: true });
        this.cpfValid = false;
        return false;
      }

      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(inputCPF.substring(10, 11))) {
        this.cpfForm.get("cpf").setErrors({ invalid: true });
        this.cpfValid = false;

        return false;
      }
      this.cpfValid = true;
      this.cpfValue = inputCPF;
      return true;
    });
  }

  cpfValido(): boolean {
    if (this.cpfValid) {
      return true;
    }
    return false;
  }

  cpfValidao0a9Sequencial(inputCPF): boolean {
    if (inputCPF == "00000000000") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }

    if (inputCPF == "11111111111") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }

    if (inputCPF == "22222222222") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }

    if (inputCPF == "33333333333") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }

    if (inputCPF == "44444444444") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }

    if (inputCPF == "55555555555") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }

    if (inputCPF == "66666666666") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }

    if (inputCPF == "77777777777") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }

    if (inputCPF == "88888888888") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }

    if (inputCPF == "99999999999") {
      this.cpfForm.get("cpf").setErrors({ invalid: true });
      this.cpfValid = false;
      return false;
    }
    return true;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }

  verificarCPF(cpf) {
    this.cpfService.buscarCPF(cpf).subscribe((cpf: any) => {
      console.log(cpf);
      let cpfCliente = cpf;

      if (cpfCliente.cpf) {
        this.openSnackBar("CPF já cadastrado!", "Fechar");
        this.cpfModalDialog.closeAll();
        return;
      }
      this._cpfService.sendCPF(this.cpfValue);
      this.cpfModalDialog.closeAll();
      this.router.navigateByUrl("/captacao");
      this.openSnackBar(
        "CPF válido, conclua o preenchimento da coleta!",
        "Fechar"
      );
    });
  }
}
